export enum CancellationReasonJobType {
  Shift = 'shift',
  Interview = 'interview',
}
